export const ENUMS = {


    TRANSACTION_INTERUPTED: [
        { value: "R", label: "Resume with transaction" },
        { value: "H", label: "Save as Held transaction" },
        { value: "Q", label: "Save a Quote" },
        { value: "D", label: "Delete this transaction" },
    ],


    DEFAULT_OPTIONS: [
        // { value: "", label: "Entry#" },
        { value: "name", label: "Name" },
        { value: "email", label: "Email" },
    ],

    COMPARE: [
        // { value: "", label: "Entry#" },
        { value: "=", label: "=" },
        { value: ">", label: ">" },
        { value: "<", label: "<" },
    ],


    //"Sale", "Held", "Adjustment", "Prpylss", "PrpyRdm", "Transfer"
    SALES_TYPES: [
        { value: "S", label: "Sale" },
        { value: "H", label: "Held" },
        { value: "A", label: "Adj" },
        { value: "P", label: "Prpylss" },
        { value: "F", label: "PrpyRdm" },
        { value: "T", label: "Transfer" },
    ],

    POS_SEARCH_SECTIONS: [
        { value: "H", label: "Held" },
        { value: "C", label: "Current" },
        { value: "L", label: "Log" },
        { value: "K", label: "Locked" },
        { value: "M", label: "Mine" },
        { value: "O", label: "Online" },
        { value: "P", label: "Prepay" },
        { value: "Q", label: "Quote" },
    ],


    REPORT_TEMPLATES: [
        { value: 1, label: "Empty" },
        { value: 2, label: "Sales" },
    ],

    REPORTS_SCOPE: [
        { value: 1, label: "Inventory" },
        { value: 2, label: "Sales from a period" },
        { value: 3, label: "Sales invoice range" },
    ],

    CUSTOMER_INDEX: [
        { value: 1, label: "Name" },
        { value: 2, label: "PostalCode" },
        { value: 3, label: "Email" },
        { value: 4, label: "EntryDate" },
        { value: 5, label: "LastActive" },
        { value: 6, label: "SalesYTD" },
        { value: 7, label: "SalesLST" },
        { value: 8, label: "SalesTTL" },
        { value: 9, label: "Points"}
    ],

    REPORTS_INDEX: [
        { value: 0, label: "None" },
        { value: 16, label: "Enter date" },
        { value: 6, label: "ISBN" },
        { value: 14, label: "Title" },
        { value: 1, label: "Author" },
        { value: 13, label: "Supplier" },
        { value: 10, label: "Publisher" },
        { value: 4, label: "Class" },
        { value: 11, label: "Total Qty Sold" },
        { value: 17, label: "Quantity Sold" },
        { value: 7, label: "Notes" },
        { value: 9, label: "Pub Date" },
        { value: 15, label: "UPC" },
        { value: 2, label: "Avail Onhand" },
        { value: 8, label: "Avail On Order" },
        { value: 5, label: "Condition Code" },
        { value: 3, label: "Binding" },
    ],

    CUSTOMER_REPORTS_INDEX: [
        { value: 0, label: "None" },
        { value: 1, label: "Name" },
        { value: 2, label: "Postal Code" },
        { value: 3, label: "Email" },
        { value: 4, label: "Entry Date" },
        { value: 5, label: "Last Active" },
        { value: 6, label: "Sales YTD" },
        { value: 7, label: "Sales LST" },
        { value: 8, label: "Sales TTL" },
        { value: 9, label: "Points" },
    ],

    SEARCH_SORT: [
        { value: "I", label: "Instock" },
        { value: "F", label: "Forthcoming" },
        { value: "R", label: "Rank" },
        { value: "P", label: "Pubdate" },
        { value: "T", label: "Title" },
    ],

    SEARCH_SCOPE: [
        { value: "A", label: "Active" },
        { value: "I", label: "Inactive" },
        { value: "B", label: "Active + Inactive" },
    ],


    CUSTOMERS_SORT: [
        // { value: "", label: "Entry#" },
        { value: "name", label: "Name" },
        { value: "ship_to", label: "Account#" },
        { value: "bill_to", label: "Billto acct#" },
        { value: "san", label: "OLact (online account)" }
    ],

    COMM_PREF: [
        { value: "", label: "No Contact" },
        { value: "E", label: "Email" },
        { value: "C", label: "Cell" },
        { value: "P", label: "Phone" },
        { value: "H", label: "Home Phone" },
        { value: "W", label: "Work Phone" },
        { value: "T", label: "Text" },
    ],

    REPORT_COLUMNS: [
        { value: 1, label: "First Received" },
        { value: 2, label: "Available OH" },
        { value: 3, label: "Available OO" },
        { value: 4, label: "Author" },
        { value: 5, label: "Backroom" },
        { value: 6, label: "Binding" },
        { value: 7, label: "Class (Main)" },
        { value: 8, label: "Condition Code" },
        { value: 9, label: "EAN" },
        { value: 10, label: "Held" },
        { value: 11, label: "ISBN" },
        { value: 12, label: "ISBN10" },
        { value: 13, label: "Last Received" },
        { value: 14, label: "Last Sold" },
        { value: 15, label: "Minimum Onhand" },
        { value: 16, label: "Message (Notes)" },
        { value: 17, label: "Multistore Onhand" },
        { value: 18, label: "Notes" },
        { value: 19, label: "On Hand" },
        { value: 20, label: "On Hand Cost Profit Margin" },
        { value: 21, label: "On Order" },
        { value: 22, label: "On Order Cost P" },
        { value: 23, label: "Pending On Order" },
        { value: 24, label: "Price" },
        { value: 25, label: "Pending Return" },
        { value: 26, label: "Pubdate" },
        { value: 27, label: "Publisher" },
        { value: 28, label: "Pubstock" },
        { value: 29, label: "Quantity" },
        // { value: 30, label: "Received/Sold Months" },
        { value: 31, label: "Received Months" },
        { value: 32, label: "Special Order" },
        { value: 33, label: "Sales Price" },
        { value: 34, label: "Section" },
        { value: 35, label: "Sales" },
        { value: 36, label: "Sales Cost P" },
        { value: 37, label: "Sold Months" },
        { value: 38, label: "Sold Price" },
        { value: 39, label: "Class (Sub)" },
        { value: 40, label: "Subject" },
        { value: 41, label: "Supplier" },
        { value: 42, label: "Title" },
        { value: 43, label: "Total Received" },
        { value: 44, label: "Total Returned" },
        { value: 45, label: "Total Sold" },
        { value: 46, label: "UPC" },
        { value: 47, label: "Used Condition" },
        { value: 48, label: "Weight" },
        { value: 49, label: "Enter Date" },
        { value: 50, label: "Class" }

    ],

    BINDINGS: [
        { value: "HC", label: "HC Hardcover" },
        { value: "PB", label: "PB Paperback" },
        { value: "TP", label: "TP Paperback" },
        { value: "DS", label: "DS 1.2M, 5.25 Disk" },
        { value: "AU", label: "AU Audio" },
        { value: "AA", label: "AA Audio" },
        { value: "AC", label: "AC Audio Cassette" },
        { value: "CD", label: "CD Audio CD" },
        { value: "AD", label: "AD Audio CD" },
        { value: "CM", label: "CM Audio CD (MP3)" },
        { value: "BA", label: "BA Bath Book" },
        { value: "BR", label: "BR Blu-ray" },
        { value: "BG", label: "BG Board Game" },
        { value: "BB", label: "BB Boardbook" },
        { value: "BD", label: "BD Boardbook" },
        { value: "BK", label: "BK Book" },
        { value: "BM", label: "BM Bookmark" },
        { value: "BX", label: "BX Box or Slipcased" },
        { value: "CA", label: "CA Calendar" },
        { value: "CS", label: "CS Cards" },
        { value: "CR", label: "CR CD-ROM" },
        { value: "CL", label: "CL Cloth Book" },
        { value: "CG", label: "CG Clothing" },
        { value: "CB", label: "CB Comb Bound" },
        { value: "DY", label: "DY Display" },
        { value: "DO", label: "DO Doll" },
        { value: "DV", label: "DV DVD" },
        { value: "EB", label: "EB E-Book" },
        { value: "GM", label: "GM Game" },
        { value: "GC", label: "GC Greeting Card" },
        { value: "TC", label: "TC Hardcover" },
        { value: "CT", label: "CT Hardcover" },
        { value: "IL", label: "IL Imitation Leather" },
        { value: "LP", label: "LP Large Print" },
        { value: "LT", label: "LT Leather/Fine Binding" },
        { value: "LB", label: "LB Library Binding" },
        { value: "LL", label: "LL Loose-Leaf" },
        { value: "MU", label: "MU Mug" },
        { value: "OA", label: "OA Otabind" },
        { value: "OT", label: "OT Other" },
        { value: "PA", label: "PA Paperback" },
        { value: "MM", label: "MM Paperback" },
        { value: "SC", label: "SC Paperback" },
        { value: "PT", label: "PT Paperback" },
        { value: "PO", label: "PO Pop Up" },
        { value: "PU", label: "PU Puzzle" },
        { value: "RB", label: "RB Ring Bound" },
        { value: "SE", label: "SE Set" },
        { value: "MP", label: "MP Sheetmap" },
        { value: "SW", label: "SW Software" },
        { value: "SP", label: "SP Spiral Bound" },
        { value: "ST", label: "ST Stapled" },
        { value: "TA", label: "TA Tableware" },
        { value: "TO", label: "TO Tote bag" },
        { value: "TY", label: "TY Toy" },
        { value: "XA", label: "XA Trade Material" },
        { value: "TR", label: "TR Transparencies" },
        { value: "VH", label: "VH VHS Video" },
        { value: "VD", label: "VD Video" },
        { value: "VB", label: "VB Vinyl Bound" },
        { value: "VP", label: "VP Vinyl Paperback" },
    ],

    CUSTOMER_FILTERS: [
        { active: true, value: 1, label: "Purch ISBN ????????????? within past 99 months", text: "a) Purch ISBN ",  text2: "within past", text3: "months", value_1: "?????????????",  value_2: "99"},
        { active: true, value: 2, label: "Purch Auth ????????????????????????? within past 99 months", text: "b) Purch Auth ", text2: "within past", text3: "months", value_1: "?????????????????????????", value_2: "99"},
        { active: true, value: 3, label: "Purch Class ????????-???????? within past 99 months", text: "c) Purch Class ", text2: "within past", text3: "months", value_1: "????????", value_2: "????????", value_3: "99"},
        { active: true, value: 4, label: "Must have a postal code"},
        { active: true, value: 5, label: "Postal Code = ??????????", text: "e) Postal Code ", comparison: "=", value_1: "??????????"},
        { active: true, value: 6, label: "City = ??????????", text: "f) City ", comparison: "=", value_1: "??????????"},
        { active: true, value: 7, label: "Prov $ ??????????", text: "g) Prov $ ", value_1: "??????????"},
        { active: true, value: 8, label: "Country = ??????????", text: "h) Country ", comparison: "=", value_1: "??????????"},
        { active: true, value: 9, label: "Phone 1 or 2 = ??????????", text: "i) Phone 1 or 2 ", comparison: "=", value_1: "??????????"},
        { active: true, value: 10, label: "SalesYTD = ######", text: "j) SalesYTD ", comparison: "=", value_1: "######"},
        { active: true, value: 11, label: "SalesLastYear = ######", text: "k) SalesLastYear ", comparison: "=", value_1: "######"},
        { active: true, value: 12, label: "SalesTtl = ######", text: "l) SalesTtl ", comparison: "=", value_1: "######"},
        { active: true, value: 13, label: "LastActive = 99/99/99", text: "m) LastActive ", comparison: "=", value_1: "99/99/99"},
        { active: true, value: 14, label: "Tags = ????????", text: "n) Tags ", comparison: "=", value_1: "????????"},
        { active: true, value: 15, label: "Entered = 99/99/99", text: "o) Entered ", comparison: "=", value_1: "99/99/99"},
        { active: true, value: 16, label: "Customer type $ ??????????", text: "p) Customer type $ ", value_1: "??????????"},
        { active: true, value: 17, label: "Terms = ??????????", text: "q) Terms ", comparison: "=", value_1: "????????"},
        { active: true, value: 18, label: "Credit limit = ######", text: "r) Credit limit ", comparison: "=", value_1: "######"},
        { active: true, value: 19, label: "Discount = ##", text: "s) Discount ", comparison: "=", value_1: "##"},
        { active: true, value: 20, label: "Frequent Buyers"},
        { active: true, value: 21, label: "Rep = ????", text: "u) Rep ", comparison: "=", value_1: "????"},
        { active: true, value: 22, label: "Billto = ???????", text: "v) Billto ", comparison: "=", value_1: "???????"},
        { active: true, value: 23, label: "Name = ???????????????", text: "w) Name ", comparison: "=", value_1: "??????????????"},
        { active: true, value: 24, label: "Attn = ???????????????", text: "x) Attn ", comparison: "=", value_1: "??????????????"},
        { active: true, value: 25, label: "Note = ???????????????", text: "y) Note ", comparison: "=", value_1: "??????????????"},
        { active: true, value: 26, label: "Ship Via = ??????????", text: "z) Ship Via ", comparison: "=", value_1: "??????????????"},
        { active: true, value: 27, label: "Address = ???????????????", text: "1) Address ", comparison: "=", value_1: "??????????????"},
        { active: true, value: 28, label: "Card expiry = 99/99/99", text: "2) Card expiry ", comparison: "=", value_1: "99/99/99"},
        { active: true, value: 29, label: "Points = #####", text: "3) Points ", comparison: "=", value_1: "#####"},
        { active: true, value: 30, label: "Phn3 = ??????????", text: "4) Phn3 ", comparison: "=", value_1: "??????????"},
        { active: true, value: 31, label: "email = ????????????????????", text: "5) email ", comparison: "=", value_1: "????????????????????"},
        { active: true, value: 32, label: "Rsvd  ISBN ????????????? in Orders file (S/O)", text: "6) Rsvd  ISBN ", text2: "in Orders file (S/O)", value_1: "?????????????"},
        { active: true, value: 33, label: "Tx code = ????", text: "7) Tx code ", comparison: "=", value_1: "????"},
        { active: true, value: 34, label: "Tax# = ????????????????????", text: "8) Tax# ", comparison: "=", value_1: "????????????????????"},
        { active: true, value: 35, label: "Held  ISBN ????????????? in POS", text: "9) Held  ISBN ", text2: "in POS ", value_1: "?????????????"},
        { active: true, value: 36, label: "Donating Points"},
        { active: true, value: 37, label: "Alert = ????????????????????", text: "A) Alert ", comparison: "=", value_1: "????????????????????"},
        { active: true, value: 38, label: "Bday = ??/??/???? ", text: "B) Bday ", comparison: "=", value_1: "??/??/????"},
        { active: true, value: 39, label: "Trade Credit = #####", text: "C) Trade Credit ", comparison: "=", value_1: "#####"},
    ],

    REPORT_FILTERS: [
        { active: false, value: -7, label: "pos types IN ?|?|?|?(1) - single char per type, [S]ale, [H]eld, [A]dj, [P]rpyIss, [F]PrpyRdm, [T]ransfers" },
        { active: false, value: -6, label: "pos invoices between ?(1) - ?(2)" },
        { active: false, value: -5, label: "pos period between ?(1) - ?(2)" },
        { active: false, value: -4, label: "Isbn prefix between ?(1) - ?(2)" },
        { active: false, value: -3, label: "Author between ?(1) - ?(2)" },
        { active: false, value: -2, label: "Class between ?(1) - ?(2)" },
        { active: false, value: -1, label: "Supplier between ?(1) - ?(2)" },
        { active: true, value: 1, label: "Total O/O =<> ###", text: "Total O/O ", comparison: "=<>", value_1: "###" },
        { active: true, value: 2, label: "Total O/H =<> ###", text: "Total O/H ", comparison: "=<>", value_1: "###" },
        { active: true, value: 3, label: "Avail O/O =<> ###", text: "Avail O/O ", comparison: "=<>", value_1: "###" },
        { active: true, value: 4, label: "Avail O/H =<> ###", text: "Avail O/H ", comparison: "=<>", value_1: "###" },
        { active: true, value: 5, label: "Total qty received =<> ###", text: "Total qty received ", comparison: "=<>", value_1: "###" },
        { active: true, value: 6, label: "Total qty sold =<> ###", text: "Total qty sold ", comparison: "=<>", value_1: "###" },
        { active: true, value: 7, label: "Total qty returned =<> ###", text: "Total qty returned ", comparison: "=<>", value_1: "###" },
        { active: true, value: 8, label: "Qty sold between yyyy-mm-dd hh:mm and yyyy-mm-dd hh:mm =<> ###", text: "Qty sold between ", comparison: "=<>", value_1: "yyyy-mm-dd hh:mm and yyyy-mm-dd hh:mm", value_2: "###" },
        { active: true, value: 9, label: "Qty received between yyyy-mm-dd and yyyy-mm-dd =<> ###", text: "Qty received between ", comparison: "=<>", value_1: "yyyy-mm-dd and yyyy-mm-dd", value_2: "###" },
        { active: true, value: 10, label: "Received between mm/dd/yy and mm/dd/yy", text: "Rcvd between ", value_1: "mm/dd/yy", value_2: "mm/dd/yy" },
        { active: true, value: 11, label: "Received from supplier ????", text: "Rcvd from supplier ", value_1: "????", },
        { active: true, value: 12, label: "First received between mm/dd/yy and mm/dd/yy", text: "First received between ", value_1: "mm/dd/yy", value_2: "mm/dd/yy" },
        { active: true, value: 13, label: "Not Yet Received (NYR) titles" },
        { active: true, value: 14, label: "ISBNs starting with ?????????????", text: "ISBNs starting with ", value_1: "?????????????" },
        { active: true, value: 15, label: "UPCs starting with ???????????????", text: "ISBNs starting with ", value_1: "???????????????" },
        { active: true, value: 16, label: "Is an ASAN" },
        { active: true, value: 17, label: "Bindings contained within ??|??|??|??|??", text: "Bindings contained within ", value_1: "??|??|??|??|??" },
        { active: true, value: 18, label: "Classes which contain ????????", text: "Classes which contain ", value_1: "????????" },
        { active: true, value: 19, label: "Sub-classes which contain ????????", text: "Sub-classes which contain ", value_1: "????????" },
        { active: true, value: 20, label: "Class-subclass = ????????-????????", text: "Class-subclass =  ", value_1: "????????", value_2: "????????" },
        { active: true, value: 21, label: "Section codes contained in ??|??|??|??|??", text: "Section codes contained in ", value_1: "??|??|??|??|??" },
        { active: true, value: 22, label: "Supplier =<>$ ????", text: "Supplier ", comparison: "=<>$", value_1: "????" },
        { active: true, value: 23, label: "Publisher = ?????", text: "Publisher = ", value_1: "?????" },
        { active: true, value: 24, label: "Titles which contain ??????????", text: "Titles which contain ", value_1: "??????????" },
        { active: true, value: 25, label: "Authors which contain ??????????", text: "Authors which contain ", value_1: "??????????" },
        { active: true, value: 26, label: "Notes which contain ??????????", text: "Notes which contain ", value_1: "??????????" },
        { active: true, value: 27, label: "Prices which are =<> #####.##", text: "NPrices which are = ", comparison: "<>", value_1: "#####.##" },
        { active: true, value: 28, label: "Avail qty O/H + O/O =<> Min O/H level", text: "Avail qty O/H + O/O ", text2: "Min O/H level" },
        { active: true, value: 29, label: "Min On Hand =<> ###", text: "Min On Hand ", comparison: "=<>", value_1: "###" },
        { active: true, value: 30, label: "Special Orders O/O =<> ###", text: "Special Orders O/O ", comparison: "=<>", value_1: "###" },
        { active: true, value: 31, label: "Pub dates =<> mm/dd/yy", text: "Pub dates ", comparison: "=<>", value_1: "mm/dd/yy" },
        { active: true, value: 32, label: "Returnable = Y/N", text: "Returnable = ", value_1: "Y/N" },
        { active: true, value: 33, label: "Backroom =<> ###", text: "Backroom ", comparison: "=<>", value_1: "###" },
        { active: true, value: 34, label: "Delisted titles" },
        { active: true, value: 35, label: "Titles marked for permanent deletion" },
        { active: true, value: 36, label: "Pubstock supplier = ?????", text: "Pubstock supplier =", value_1: "?????", instructions: "(leave blank for any PubStock matches)" },
        { active: true, value: 37, label: "Titles with pending returns" },
        { active: true, value: 38, label: "Returned between mm/dd/yy and mm/dd/yy", text: "Returned between ", value_1: "mm/dd/yy", value_2: "mm/dd/yy" },
        { active: true, value: 39, label: "Returned to supplier ????", text: "Returned to supplier ", value_1: "????" },
        { active: true, value: 40, label: "Return reason ???????????", text: "Return reason ", value_1: "???????????" },
        { active: true, value: 41, label: "Sales with Customer Types ?|?|?|?|?|?|?|?|?", text: "Sales with Customer Types ", value_1: "?|?|?|?|?|?|?|?|?" },
        { active: true, value: 42, label: "Sales done by POS Groups ?|?|?|?|?", text: "Sales done by POS Groups ", value_1: "?|?|?|?|?" },
        { active: true, value: 43, label: "One-time special orders" },
        { active: true, value: 44, label: "Condition code matching ?", text: "Condition code matching ", value_1: "?" },
        { active: true, value: 45, label: "Used book condition code matching = ?", text: "Used book condition code matching = ", value_1: "?" },
        { active: true, value: 46, label: "Is used book" },
        { active: true, value: 47, label: "Active and PubDate is ?? Tuesday(s) from now (and 7 days prior)", value_1: "??", text: "Active and PubDate is", text2: "Tuesday(s) from now (and 7 days prior)" },
        { active: true, value: 48, label: "BISAC Subject = ?????????", text: "BISAC Subject = ", value_1: "?????????" },
        { active: true, value: 49, label: "Adjusted reason = ?????????", text: "Adjusted reason = ", value_1: "?????????" },
        { active: true, value: 50, label: "Consignment (in stock)" },
        { active: true, value: 51, label: "Qty received in last # months =<> ###", text: "Qty received in ", comparison: "=<>", value_1: "#", value_2: "###" },
    ],

    REPORT_SORT_FILTER: [
        { value: "updated", label: "Updated" },
        { value: "name", label: "Name" },
        { value: "clerk", label: "Clerk" },
    ],

    ORDER_UPDATE_OPTIONS: [
        { key: "reset_pending", value: true, label: "Reset pending entries to supplier defaults?" },
        { key: "mark_pending", value: true, label: "Mark pending orders that meet minimums?" },
        { key: "update_sent", value: false, label: "Update status for Sent orders?" },
        { key: "update_received", value: false, label: "Update status for Rcvd orders (slow)?" },
    ],

    ORDER_STATUS: [
        { value: "Pend", label: "Pending" },
        { value: "Ordr", label: "O/O On Order" },
        { value: "OSTO", label: "O/O SingleTitleOrd" },
        { value: "OEml", label: "O/O email" },
        { value: "ORep", label: "O/O Rep" },
        { value: "OWeb", label: "O/O Web/online" },
        { value: "OMai", label: "O/O Mail" },
        { value: "OFax", label: "O/O Fax" },
        { value: "OPhn", label: "O/O Phone" },
        { value: "OBkn", label: "O/O BookNet/Pubnet" },
        { value: "OCnf", label: "O/O Confirmed stock" },
        { value: "ONet", label: "O/O Netftp" },
        { value: "OInt", label: "O/O MS InterStore" },
        { value: "OAck", label: "O/O Acknowledged" },
        { value: "Ship", label: "O/O Ship/Invoiced" },
        { value: "ODTH", label: "O/O DirectToHome" },
        { value: "BDTH", label: "B/O DirectToHome" },
        { value: "DTH", label: "O/O DirectToHome" }, // confirmed
        { value: "SDTH", label: "O/O Ship/DirectToHome" },
        { value: "Rcvd", label: "Received" },
        { value: "RDTH", label: "Received DirectToHome" },
        // { value: "Avai", label: "Available stock" },
        { value: "BOS", label: "B/O Out of Stock" },
        { value: "BNYP", label: "B/O Not Yet Pub" },
        { value: "BRP", label: "B/O Reprinting" },
        { value: "BITO", label: "B/O Import To Order" },
        { value: "COS", label: "Cancel O/S" },
        { value: "CNYP", label: "Cancel Not Yet Pub" },
        { value: "CBC", label: "Cancel By Cust" },
        { value: "CBU", label: "Cancel By Us" },
        { value: "CNOP", label: "Cancel Not Our Pub" },
        { value: "CNR", label: "Cancel No Rights" },
        { value: "COP", label: "Cancel Out of Print" },
        { value: "CNL", label: "Cancel No Listing" },
        { value: "CNW", label: "Cancel No word" },
        { value: "COSI", label: "Cancel O/S Indef." },
        { value: "CPXL", label: "Cancel Publication" },
        { value: "CRP", label: "Cancel Reprinting." },
        { value: "CITO", label: "Cancel Imp to Order" }
    ]
}
